module.exports = __webpack_public_path__ + "static/media/icon-emoji-good.dcf2f3e4.svg";